import '@/plugins'
import components from '@/views/components'
import directive from '@/views/directives'
import filters from '@/views/filters'
import mixins from '@/views/mixins'
import Vue from 'vue'

class Register {
	registerAll() {
		Vue.use(components)
		Vue.use(directive)
		Vue.use(filters)
		Vue.use(mixins)
	}
}

export default new Register()
